/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAttachmentsQueryResponse,
  GetApiV1PersonIdAttachmentsPathParams,
  GetApiV1PersonIdAttachments401,
  GetApiV1PersonIdAttachments404,
  GetApiV1PersonIdAttachments500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachments.ts";

function getGetApiV1PersonIdAttachmentsUrl(
  id: GetApiV1PersonIdAttachmentsPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/attachments` as const,
  };
  return res;
}

/**
 * @description Lista os anexos de documentos de matrícula da pessoa. **(Requer Authorization para autenticação)**
 * @summary Listar anexos de matrícula da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments}
 */
export async function getApiV1PersonIdAttachments(
  id: GetApiV1PersonIdAttachmentsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAttachmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachments401
      | GetApiV1PersonIdAttachments404
      | GetApiV1PersonIdAttachments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAttachmentsUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
